const FA_DIGITS = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'] as const
const FA_DIGIT_STR = '۰۱۲۳۴۵۶۷۸۹'
const AR_DIGIT_STR = '٠١٢٣٤٥٦٧٨٩'

/** Convert Western digits in a string to Persian digits. */
export function toFaDigits(value: string | number): string {
  return String(value).replace(/\d/g, (d) => FA_DIGITS[Number(d)] ?? d)
}

/** Convert Persian / Arabic-Indic digits to Western digits. */
export function toEnDigits(value: string): string {
  return String(value)
    .replace(/[۰-۹]/g, (d) => String(FA_DIGIT_STR.indexOf(d)))
    .replace(/[٠-٩]/g, (d) => String(AR_DIGIT_STR.indexOf(d)))
}

/** Format seconds as MM:SS with Persian digits (e.g. ۰۱:۵۹). */
export function formatFaCountdown(totalSeconds: number): string {
  const clamped = Math.max(0, Math.floor(totalSeconds))
  const minutes = Math.floor(clamped / 60)
  const seconds = clamped % 60
  const mm = String(minutes).padStart(2, '0')
  const ss = String(seconds).padStart(2, '0')
  return toFaDigits(`${mm}:${ss}`)
}
